import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const OnlyLableNav = (props) => {

    return (
        <>
            {props?.v.status && !Object.values(props.menuList).some((submenu) => submenu.parent_menu_code === props?.v.code) && !(props?.v.location == "sub_menu" && !props?.v.parent_menu_code) ? (

                <li className="only-lable-menu" key={props?.v.code}>

                    <NavLink to={props?.customLink} onMouseOver={() => props?.mouseOver(props?.v.code)}>
                        <span>
                            {props.t(`${props?.v?.name.toLowerCase().replace(/ /g, '_')}`)}
                        </span>
                    </NavLink>
                </li>
            ) : null}
        </>
    );
};

OnlyLableNav.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(OnlyLableNav);
